import React from "react";

const Terms = () => {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        src="https://mooshir.com/assets/pdf/mooshir-terms-and-conditions-v2.0.pdf"
        title="Mooshir Terms And Conditions"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default Terms;
